// DASHBOARD index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    activityGraph: {
      delivered: [],
      deviations: [],
      not_delivered: [],
    },
    deviationsGraph: [],
    performanceGraph: {
      delivered: 0,
      delivered_percent: 0,
      deviations: 0,
      deviations_percent: 0,
      in_transit: 0,
      in_transit_percent: 0,
      ready_to_ship: 0,
      ready_to_ship_percent: 0,
      total_shipments: 0,
    },
    mapGraph: {
      continent_total: {
        AF: {
          total_delivery_by_continent: 0,
          total_issue_by_continent: 0,
        },
        AN: {
          total_delivery_by_continent: 0,
          total_issue_by_continent: 0,
        },
        AS: {
          total_delivery_by_continent: 0,
          total_issue_by_continent: 0,
        },
        EU: {
          total_delivery_by_continent: 0,
          total_issue_by_continent: 0,
        },
        NA: {
          total_delivery_by_continent: 0,
          total_issue_by_continent: 0,
        },
        SA: {
          total_delivery_by_continent: 0,
          total_issue_by_continent: 0,
        },
        OC: {
          total_delivery_by_continent: 0,
          total_issue_by_continent: 0,
        },
      },
    },
    carrierGraph: {
      carriers: [],
    },
    shipmentsGraph: [],
    dummyMap: {
      EU: {
        Denmark: {
          country_name: 'Denmark',
          country_alpha3: 'DNK',
          continent: 'EU',
          delivered_count: 0,
          issue_count: 3,
          on_the_way_count: 0
        },
        Norway: {
          country_name: 'Norway',
          country_alpha3: 'NOR',
          continent: 'EU',
          delivered_count: 4,
          issue_count: 0,
          on_the_way_count: 0
        }
      },
      continent_total: {
        EU: {
          total_delivery_and_on_the_way_by_continent: 4,
          total_issue_by_continent: 3
        },
        AF: {
          total_delivery_and_on_the_way_by_continent: 0,
          total_issue_by_continent: 0
        },
        AN: {
          total_delivery_and_on_the_way_by_continent: 0,
          total_issue_by_continent: 0
        },
        AS: {
          total_delivery_and_on_the_way_by_continent: 0,
          total_issue_by_continent: 0
        },
        NA: {
          total_delivery_and_on_the_way_by_continent: 0,
          total_issue_by_continent: 0
        },
        SA: {
          total_delivery_and_on_the_way_by_continent: 0,
          total_issue_by_continent: 0
        },
        OC: {
          total_delivery_and_on_the_way_by_continent: 0,
          total_issue_by_continent: 0
        }
      }
    }
  },
  actions,
  mutations,
  getters,
};
